export enum PageDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export const initialPageParams: PageParams = {
  page: 1,
  pageSize: 25,
};

export interface PageParams {
  page: number;
  pageSize: number;
}

export interface PageWrapperDTO<T> {
  content: T[];
  direction: PageDirection;
  numberOfElement: number;
  orderBy?: {
    fieldName: string;
  };
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export const commonPaginationConfig = {
  pageSizeOptions: ['25', '50', '100'],
};
